import React, { useState, useMemo } from "react";
import HearNUFormCreateUI from "../customhearnuform/HearNUFormCreateUI";
import moment from "moment";
import { createFormApi } from "../../apis/hearnuform.api";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { closeModal, openModal } from "../../store/actions/modalAction";

import PopUpModal from "../../components/Modal";

import HeadMeasurementModal from "./HeadMeasurementModal";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import InstructionModal from "./InstructionModal";

const HearNUFormCreateController = () => {
  const [loading, setLoading] = useState(false);
  const validate = useValidate();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fields, setFields] = useState({
    err: "",
    name: "",
    dob: moment(),
    age: 0,
    ethnicity: "",
    gender: "",
    country: "",
    upperHeadCircumference: null,
    temporalBoneWidth: null,
    foreheadToBackheadCircumference: null,
  });

  const createFunction = async (e) => {
    const validationResponse = validate(validationSchemaForHearNUForm);
    console.log("validationResponse", validationResponse);
    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await createFormApi({ ...fields }),
          async (response) => {
            setLoading(false);
            dispatch(
              callSnackBar(
                "Form Submitted Successfully",
                SNACK_BAR_VARIETNS.success
              )
            );
            setFields({
              err: "",
              name: "",
              dob: moment(),
              age: 0,
              ethnicity: "",
              gender: "",
              country: "",
              upperHeadCircumference: "",
              temporalBoneWidth: "",
              foreheadToBackheadCircumference: "",
            });
            navigate("/form-submitted");
          },
          (err) => {
            setLoading(false);
            dispatch(callSnackBar("Error", SNACK_BAR_VARIETNS.error));
            setFields((prevFields) => ({ ...prevFields, err }));
          }
        )
      );
    } else {
      setFields((prevFields) => ({ ...prevFields, err: validationResponse }));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    createFunction(e);
  };

  const validationSchemaForHearNUForm = useMemo(
    () => [
      { required: true, value: fields?.name, field: "Name" },
      { required: true, value: fields?.age, field: "Age" },
      { required: true, value: fields?.ethnicity, field: "Ethnicity" },
      { required: true, value: fields?.gender, field: "Gender" },
      { required: true, value: fields?.country, field: "Country" },
      {
        required: true,
        value: fields?.upperHeadCircumference,
        field: "UpperHead Circumference",
      },
      {
        required: true,
        value: fields?.temporalBoneWidth,
        field: "Temporal Bone Width",
      },
      {
        required: true,
        value: fields?.foreheadToBackheadCircumference,
        field: "Forehead To Backhead Circumference",
      },
    ],
    [fields]
  );

  // const handleCaptureMeasurement = () => {
  //   dispatch(
  //     openModal(
  //       <HeadMeasurementModal
  //         onClose={() => dispatch(closeModal())}
  //         onMeasurementComplete={(values) => {
  //           console.log("📦 Measurement received from modal:", values);
  //           setFields((prev) => ({
  //             ...prev,
  //             upperHeadCircumference: values["Temporal Arc (cm)"] || "",
  //             temporalBoneWidth: values["Temporal Width (cm)"] || "",
  //             foreheadToBackheadCircumference:
  //               values["Head Circumference (cm)"] || "",
  //           }));
  //         }}
  //       />,
  //       "md",
  //       true
  //     )
  //   );
  // };


const handleCaptureMeasurement = () => {
  dispatch(
    openModal(
      <InstructionModal
        onReady={() => {
          dispatch(closeModal("instruction-modal")); 
          setTimeout(() => {
            dispatch(
              openModal(
                <HeadMeasurementModal
                  onClose={() => dispatch(closeModal())}
                  onMeasurementComplete={(values) => {
                    console.log("📦 Measurement received from modal:", values);
                    setFields((prev) => ({
                      ...prev,
                      upperHeadCircumference: values["Temporal Arc (cm)"] || "",
                      temporalBoneWidth: values["Temporal Width (cm)"] || "",
                      foreheadToBackheadCircumference:
                        values["Head Circumference (cm)"] || "",
                    }));
                  }}
                />,
                "md",
                true
              )
            );
          }, 300); 
        }}
      />,
      "sm", 
      true,
      "instruction-modal"
    )
  );
};

  return (
    <Box sx={{overflow:"hidden", height: "100vh",scrollbarWidth:"thin"}}>
      <HearNUFormCreateUI
        loading={loading}
        setLoading={setLoading}
        handleCaptureMeasurement={handleCaptureMeasurement}
        fields={fields}
        setFields={setFields}
        onSubmit={onSubmit}
      />
      <PopUpModal />
    </Box>
  );
};

export default HearNUFormCreateController;
